import Vue from "vue";

// initial state
const state = {
  addCompaireMovieMoreThanTen: true
};

// getters
const getters = {
  getAddCompaireMovieMoreThanTen(state) {
    return state.addCompaireMovieMoreThanTen;
  }
};

// actions
const actions = {

};

// mutations
const mutations = {
  setAddCompaireMovieMoreThanTen(state, payload = { status: undefined }) {
    state.addCompaireMovieMoreThanTen = payload.status;
    return state;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
